// extracted by mini-css-extract-plugin
export default {"cls1":"WorkCard-cls1_Q2H","cls2":"WorkCard-cls2_NW2 WorkCard-cls1_Q2H"};